import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Form, Button, Spinner } from "react-bootstrap";
import { getPonOLTById, updatePonOLT } from "../services/ponOLTService";
import FormComponent from "./common/formComponent";
import PageLoading from "./common/pageLoading";
import { Paper } from "@material-ui/core";

class PonOLTInfo extends FormComponent {
  state = {
    data: {
      _id: "",
      name: "",
      model: "",
      host: "",
      sshPort: "",
      username: "",
      password: "",
      pingTime: "",
      nRouterId: "",
    },
    errors: {},
    router: {},
    loading: true,
    processing: false,
  };

  schema = {
    _id: Joi.string().required().label("Id"),
    name: Joi.string().required().label("Name"),
    model: Joi.string().required().label("Model"),
    host: Joi.string().required().label("Host/IP"),
    sshPort: Joi.number().min(1).required().label("SSH Port"),
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
    pingTime: Joi.string().required().label("Ping Time"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload } = this.state;

    try {
      await updatePonOLT(payload);

      this.props.history.push("/ponolts");
      toast.success("PON OLT Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    const { data } = await getPonOLTById(this.props.match.params.id);
    this.setState({ data, loading: false });
  }

  render() {
    const { data, errors, loading, processing } = this.state;

    return (
      <Paper elevation={3}>
        <div className="card">
          <div className="card-header main-color-bg">
            <div className="row">
              <div className="col-md">
                <h5>
                  {data.name} ({data.host})
                </h5>
              </div>
              <div className="col-md"></div>
            </div>
          </div>
          <div className="card-body">
            {loading && <PageLoading loading={loading} />}
            {!loading && (
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="name"
                    onChange={this.handleChange}
                    value={data.name}
                    size="sm"
                    type="text"
                    autoFocus
                  />
                  {errors.name && <span className="text-danger">{errors.name}</span>}
                </Form.Group>

                <Form.Group controlId="model">
                  <Form.Label>Model</Form.Label>
                  <Form.Control name="model" onChange={this.handleChange} value={data.model} size="sm" type="text" />
                  {errors.model && <span className="text-danger">{errors.model}</span>}
                </Form.Group>

                <Form.Group controlId="host">
                  <Form.Label>Host/IP</Form.Label>
                  <Form.Control name="host" onChange={this.handleChange} value={data.host} size="sm" type="text" />
                  {errors.host && <span className="text-danger">{errors.host}</span>}
                </Form.Group>

                <Form.Group controlId="sshPort">
                  <Form.Label>SSH Port</Form.Label>
                  <Form.Control
                    name="sshPort"
                    onChange={this.handleChange}
                    value={data.sshPort}
                    size="sm"
                    type="text"
                  />
                  {errors.sshPort && <span className="text-danger">{errors.sshPort}</span>}
                </Form.Group>

                <Form.Group controlId="username">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    name="username"
                    onChange={this.handleChange}
                    value={data.username}
                    size="sm"
                    type="text"
                  />
                  {errors.username && <span className="text-danger">{errors.username}</span>}
                </Form.Group>

                <Form.Group controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    name="password"
                    onChange={this.handleChange}
                    value={data.password}
                    size="sm"
                    type="password"
                  />
                  {errors.password && <span className="text-danger">{errors.password}</span>}
                </Form.Group>
                
                <Button disabled={this.validate() || processing} type="submit" variant="primary">
                  {processing && (
                    <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                  )}
                  Update
                </Button>
              </Form>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}

export default PonOLTInfo;
